import React from 'react'

export const NotificationOff = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill={props.fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_34_3930)'>
      <path
        d='M18.586 20.0001H4C3.90714 20.0001 3.81612 19.9742 3.73713 19.9254C3.65814 19.8766 3.59431 19.8067 3.55278 19.7237C3.51126 19.6406 3.49368 19.5476 3.50202 19.4552C3.51036 19.3627 3.54428 19.2744 3.6 19.2001L4 18.6671V10.0001C4 8.67007 4.324 7.41607 4.899 6.31307L1.393 2.80807L2.808 1.39307L22.607 21.1931L21.192 22.6071L18.586 20.0001ZM20 15.7861L7.559 3.34507C8.76374 2.54101 10.1642 2.07912 11.6109 2.00867C13.0576 1.93822 14.4963 2.26186 15.7734 2.94505C17.0506 3.62824 18.1183 4.64535 18.8627 5.88785C19.6071 7.13036 20.0002 8.55165 20 10.0001V15.7861ZM9.5 21.0001H14.5C14.5 21.6631 14.2366 22.299 13.7678 22.7678C13.2989 23.2367 12.663 23.5001 12 23.5001C11.337 23.5001 10.7011 23.2367 10.2322 22.7678C9.76339 22.299 9.5 21.6631 9.5 21.0001Z'
        fill={props.fill || 'currentColor'}
      />
    </g>
    <defs>
      <clipPath id='clip0_34_3930'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
